import { type IAgentReducer } from '../../interface/IReducer';

export default function resultReducer(state = {} as IAgentReducer, action: { type: string; payload: any }) {
	// if (action.type in state) {
	return { ...state, [action.type]: action.payload };
	// }
	// return state
}
